import React, { useMemo, useState } from 'react';
import styles from './index.module.scss';

import { Modal } from 'antd';
import moment, { Moment } from 'moment';
import MeetingDetailDialog from '../MeetingDetailDialog';
import { ModalWidth } from 'page/MeetingSchedule/types/type';
import { detailModalCaculate } from 'page/MeetingSchedule/utils/modalPosition';
import classnames from 'classnames';

interface IProps {
  show: boolean;
  modalTop?: number;
  modalLeft?: number;
  currentTime: Moment;
  meetingList: any[];
  onCancel?: () => void;
}
const weeks = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
const MoreMeetingDialog: React.FC<IProps> = ({ show, modalTop, modalLeft, currentTime, meetingList, onCancel }) => {
  const showModalStyle = !!modalTop && !!modalLeft;
  const modalStyle = showModalStyle ? { left: modalLeft, top: modalTop, margin: 0 } : {};
  const [isShowMeetingDetail, setIsShowMeetingDetail] = useState(false);
  const [detailModalPosition, setDetailModalPostion] = useState({ left: 0, top: 0 });

  const [currentActiveItem, setCurrentActiveItem] = useState<number>(-1);

  const handleCancel = () => {
    onCancel && onCancel();
  };

  const handleOpenDetail = (e: any, index: number) => {
    e.stopPropagation();
    const target = e.currentTarget;
    const rect = target.getBoundingClientRect();
    const { top, left } = detailModalCaculate(rect);
    setDetailModalPostion({ top, left });
    setIsShowMeetingDetail(true);
    setCurrentActiveItem(index);
  };

  const currentSchedule = useMemo(() => {
    if (currentActiveItem > -1) {
      return meetingList[currentActiveItem];
    }
    return {};
  }, [currentActiveItem]);

  // 子item的样式（选中时的样式）
  const itemAcviveClassName = (index: number) => {
    return classnames(styles.meeting_list_item, {
      [styles.meeting_list_item_active]: index == currentActiveItem
    });
  };
  return (
    <>
      <Modal
        className={styles.modal}
        style={modalStyle}
        footer={null}
        maskStyle={{ backgroundColor: 'transparent' }}
        visible={show}
        width={ModalWidth}
        onCancel={handleCancel}
        destroyOnClose
      >
        <div className={styles.data_content}>
          <div className={styles.day}>{currentTime?.format('D')}</div>
          <div className={styles.week}>{weeks[currentTime?.day()]}</div>
        </div>
        <div className={styles.modal_content}>
          {meetingList &&
            meetingList.map((item, index) => {
              return (
                <div
                  key={item.id}
                  className={itemAcviveClassName(index)}
                  onClick={(e) => {
                    handleOpenDetail(e, index);
                  }}
                >
                  <div className={styles.meeting_list_item_icon}></div>
                  <div className={styles.meeting_list_item_text}>
                    {moment(Number(item.beginTime)).format('HH:mm') + ' '}
                    {item.subject}
                  </div>
                </div>
              );
            })}
        </div>
      </Modal>

      <MeetingDetailDialog
        modalLeft={detailModalPosition.left}
        modalTop={detailModalPosition.top}
        show={isShowMeetingDetail}
        scheduleDetail={currentSchedule}
        onCancel={() => {
          setIsShowMeetingDetail(false);
          setCurrentActiveItem(-1);
        }}
      ></MeetingDetailDialog>
    </>
  );
};

export default MoreMeetingDialog;
